import { gql } from '@apollo/client';

const atlAppraiserInfoFragment = gql`
  fragment AtlAppraiserInfoFields on AppraiserInfo {
    ExternalUserId
    UserLicense {
      Name
    }
    Observation
    CurrentRole {
      Title
      Value
    }
    DomainExperiences {
      Domain
    }
  }
`;

export default atlAppraiserInfoFragment;
